module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form',
    ],

    methods: {
        onBeforeRender: function(){
            this.model.nodeData = this.getResourceRegisterContent('nodeData') || {}
        }
    },

    hooks: {
        attach: function(){
            const self = this;
            if(!self.model.parentModal){
                self.closest('base_modal_modal', function(modal){
                    self.model.parentModal = modal
                })
            }

            let entityTitle = ((self.model.nodeData || {}).attributes || {}).entityTitle
            if(self.model.parentModal && entityTitle){
                self.model.parentModal.model.subTitle = entityTitle
                self.model.parentModal.$.find('.window > .header > .title > .subTitle').html(entityTitle)
            }
        }
    }
}
